import {
  LayoutDashboard,
  Tags,
  Bookmark,
  FileText,
  BotMessageSquare,
  ScrollText,
  BarChart3,
  FolderTree,
  Link2,
  ScanSearch,
  Layers,
  BookOpen,
  Users,
  Server,
  Shield,
  FileCode2,
  GitBranch,
} from 'lucide-react'
import type { NavItem } from '@/types/platform'

export const pacNavItems: readonly NavItem[] = [
  { title: 'Dashboard', url: '/pac/dashboard', icon: LayoutDashboard },
  { title: 'Attributes', url: '/pac/attributes', icon: Tags },
  { title: 'Data Classification', url: '/pac/resource-tags', icon: Bookmark },
  { title: 'Policies', url: '/pac/policies', icon: FileText },
  { title: 'poli-x - AI', url: '/polix-ai', icon: BotMessageSquare },
  { title: 'Analytics', url: '/pac/analytics', icon: BarChart3 },
  { title: 'Infrastructure', url: '/pac/infrastructure', icon: Server },
  { title: 'Users', url: '/pac/users', icon: Users },
]

export const discoveryNavItems: readonly NavItem[] = [
  { title: 'Dashboard', url: '/discovery/dashboard', icon: LayoutDashboard },
  { title: 'Applications', url: '/discovery/connections', icon: Link2 },
  { title: 'Categorization', url: '/discovery/classifications', icon: Layers },
  { title: 'Scans', url: '/discovery/scans', icon: ScanSearch },
  { title: 'Data Catalog', url: '/discovery/data-catalog', icon: FolderTree },
  { title: 'poli-x - AI', url: '/polix-ai', icon: BotMessageSquare },
]

export const identityNavItems: readonly NavItem[] = [
  { title: 'Dashboard', url: '/identity/dashboard', icon: LayoutDashboard },
  { title: 'Subjects', url: '/identity/subjects', icon: Users },
  { title: 'IdP Connections', url: '/identity/connections', icon: Link2 },
  { title: 'Audit Logs', url: '/identity/audit-logs', icon: ScrollText },
  { title: 'poli-x - AI', url: '/polix-ai', icon: BotMessageSquare },
]

export const polixAiNavItems: readonly NavItem[] = [
  { title: 'poli-x - AI', url: '/polix-ai', icon: BotMessageSquare },
]

export const docsNavItems: readonly NavItem[] = [
  { title: 'Getting Started', url: '/docs/getting-started', icon: BookOpen },
  { title: 'What is ABAC?', url: '/docs/abac', icon: Shield },
  { title: 'XACML Basics', url: '/docs/xacml', icon: FileCode2 },
  { title: 'Attributes', url: '/docs/attributes', icon: Tags },
  { title: 'Policies', url: '/docs/policies', icon: FileText },
  { title: 'Request Evaluation', url: '/docs/evaluation', icon: GitBranch },
  { title: 'Architecture', url: '/docs/architecture', icon: Server },
]
